import { createBrowserRouter } from "react-router";
import { AppLayout } from "./components/AppLayout.js";
import { HomePage } from "./pages/HomePage.js";
import { SearchPage } from "./pages/SearchPage.js";
import { StockDetailPage } from "./pages/StockDetailPage.js";
import { CrossPage } from "./pages/CrossPage.js";
import { CrossFormPage } from "./pages/CrossFormPage.js";
import { YutaiPage } from "./pages/YutaiPage.js";
import { MyPage } from "./pages/MyPage.js";
import { HoldingsPage } from "./pages/HoldingsPage.js";
import { BrokersPage } from "./pages/BrokersPage.js";
import { SettingsPage } from "./pages/SettingsPage.js";
import { LegalPage } from "./pages/LegalPage.js";
import { LoginPage } from "./pages/LoginPage.js";
import { FavoritesPage } from "./pages/FavoritesPage.js";
import { SummaryPage } from "./pages/SummaryPage.js";
import { LongTermPage } from "./pages/LongTermPage.js";
import { AdminPage } from "./pages/AdminPage.js";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: AppLayout,
    children: [
      { index: true, Component: HomePage },
      { path: "login", Component: LoginPage },
      { path: "search", Component: SearchPage },
      { path: "stocks/:code", Component: StockDetailPage },
      { path: "cross", Component: CrossPage },
      { path: "cross/:id", Component: CrossFormPage },
      { path: "yutai", Component: YutaiPage },
      { path: "my", Component: MyPage },
      { path: "my/holdings", Component: HoldingsPage },
      { path: "my/brokers", Component: BrokersPage },
      { path: "my/favorites", Component: FavoritesPage },
      { path: "my/summary", Component: SummaryPage },
      { path: "my/long-term", Component: LongTermPage },
      { path: "admin", Component: AdminPage },
      { path: "my/settings", Component: SettingsPage },
      { path: "legal/:doc", Component: LegalPage },
    ],
  },
]);
